// --------------------------------------------------------
// OPEN APPOINTMENTS - OpenAppointments
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------

import React from "react";
import { useNavigate } from "react-router-dom";
import useResponsiveInfo from "../../../../../../hooks/useResponsiveInfo";
import { IDataOpen } from "../../AttendanceRecord";
import {
  BoxIcons,
  BoxStatus,
  Container,
  Icon,
  Line,
  Status,
  Text,
} from "./OpenAppointments.styled";

import EditIcon from "../../../../../../assets/imgs/edit-blue.svg";
import DeleteIcon from "../../../../../../assets/imgs/delete-red.svg";
import moment from "moment";
import { getDescricaoByCodigoAppointmentStatus } from "../../../../../../enums/AppointmentStatus";
import { Paths } from "../../../../../../enums/Paths";
import { useSelector } from "react-redux";

// --------------------------------------------------------
// OPEN APPOINTMENTS INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

export interface IOpenAppointments {
  data: IDataOpen[];
  pessoa: any;
  agendamento: any;
  onDelete: (id: string)=>void;
}

function OpenAppointments({ data, pessoa, agendamento, onDelete }: IOpenAppointments): JSX.Element {
  // --------------------------------------------------------
  // OPEN APPOINTMENTS PRIVATE DECLARATIONS
  // --------------------------------------------------------

  const { isMobile } = useResponsiveInfo();
  const navigate = useNavigate();
  const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)

  return (
    <Container isMobile={isMobile}>
      {data.map((data: any) => {

        const { horario, id, statusPresenca } = data;

        const navigateToEdit = () => {
          navigate(Paths.RegistroAtendimento, { state: { pessoa: pessoa, atendimentoId: id, finalizado: false, agendamento: agendamento} })
        }

        const deleteAtendimento = async ()=>{
          onDelete(id)
        }

        return <Line>
          <BoxStatus>
            <Text bold>{moment(horario).format('DD/MM/YYYY')}</Text> <Status>{getDescricaoByCodigoAppointmentStatus(statusPresenca)}</Status>
          </BoxStatus>
          {
            !acessoProntuario ?
              <BoxIcons>
              <Icon src={EditIcon} width={20} height={20} onClick={navigateToEdit} />
              <Icon src={DeleteIcon} width={24} height={24} onClick={deleteAtendimento}/>
            </BoxIcons>
            :
              ''
          }

        </Line>
      })}
    </Container>
  );
}

export default OpenAppointments;
